import React, { useState } from 'react';
import {
  Link as RouterLink,
  useHistory,
} from 'react-router-dom';
import {
  Breadcrumbs,
  Divider,
  Grid,
  IconButton,
  Link,
  Toolbar,
  Tooltip,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowBack } from '@material-ui/icons';
import ItemDelete from './Components/ItemDelete';
import OrganizationTree from './Components/OrganizationTree';
import UserTable from './Components/UserTable';
import { Auth } from 'aws-amplify';
import { ACCESS, host } from "../../data";
import { isValidEmail } from '../../helpers/isValidEmail';
import BranchesNavigationButton from '../Components/BranchNavigationButton';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  content: {
    padding: theme.spacing(2),
  },
  grow: {
    flexGrow: 1,
  },
  dividerSpacing: { marginBottom: theme.spacing(2) },
}));

export default function OrgManage({ orgInfo, fetchOrgInformation }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const history = useHistory();
  const [selected, setSelected] = useState({});
  const [orgTree, setOrgTree] = useState([]);
  const [branches, setBranches] = useState([]);
  const [allowItemDelete, setAllowItemDelete] = useState(false);
  const [currentUser, setCurrentUser] = useState("");
  const [moveDestinations, setMoveDestinations] = useState([]);
  
  React.useEffect(() => {
    fetchBranchData();
  }, [orgInfo]);

  React.useEffect(() => {
    var allowDelete = false;
    var lMoveDestinations = [];
    var parentId = 0;
    //console.log(orgTree);
    if (selected.type !== undefined) {
      if (selected.type === "ORG") {
        allowDelete = (orgTree.length == 1 ? true : false);
      }
      else if (selected.type === "BRANCH") {
        for (var i = 1; i < orgTree.length; i++) {
          if (orgTree[i].id === selected.id) {
            allowDelete = (orgTree[i].children.length == 0 ? true : false);
            break;
          }
        }
      }
      else if (selected.type === "SITE") {
        for (var i = 1; i < orgTree.length; i++) {
          for (var k = 0; k < orgTree[i].children.length; k++) {
            if (orgTree[i].children[k].id === selected.id) {
              allowDelete = (orgTree[i].children[k].children.length == 0 ? true : false);
              parentId = orgTree[i].id;
            }
          }
          if(orgTree[i].id !== parentId){
            lMoveDestinations.push({id: orgTree[i].id, name: orgTree[i].name});
          }
        }
      }
      else if (selected.type === "TANK") {
        for (var i = 1; i < orgTree.length; i++) {
          for (var k = 0; k < orgTree[i].children.length; k++) {
            for (var j = 0; j < orgTree[i].children[k].children.length; j++){
              if (orgTree[i].children[k].children[j].id === selected.id) {
                parentId = orgTree[i].children[k].id;
              }
            }
            if(orgTree[i].children[k].id !== parentId){
              lMoveDestinations.push({id: orgTree[i].children[k].id, name: orgTree[i].name + " / " + orgTree[i].children[k].name});
            }
          }
        }
      }
    }
    //console.log(lMoveDestinations);
    setMoveDestinations(lMoveDestinations);
    setAllowItemDelete(allowDelete);
  }, [selected])

  function fetchBranchData() {
    Auth.currentAuthenticatedUser()
      .then(data => {
        setCurrentUser(data.username);

        var requestOptions = {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': data.signInUserSession.idToken.jwtToken
          }
        };

        fetch(host + '/orgs/' + orgInfo.orgId
          + '/branches', requestOptions)
          .then(results => results.json())
          .then(data => {
            // If no branch exists, send the user to the branch creation page.
            setBranches(
              data.data.branchesList
            );
          }).catch((error) => {
            console.log(error);
          });
      });
  }


  React.useEffect(() => {
    if (selected.id !== undefined) {
      if (selected.id === 'root') {
        setSelected(orgTree[0]);
      }
      else {
        for (var i = 1; i < orgTree.length; i++) {
          if (selected.type === "SITE") {
            for (var k = 0; k < orgTree[i].children.length; k++) {
              if (selected.id === orgTree[i].children[k].id) {
                setSelected(orgTree[i].children[k]);
                break;
              }
            }
          }
          else {
            if (selected.id === orgTree[i].id) {
              setSelected(orgTree[i]);
              break;
            }
          }
        }
      }
    }
    else if (orgTree[0] !== undefined) {
      setSelected(orgTree[0]);
    }
  }, [orgTree]);

  React.useEffect(() => {
    fetchOrgTree();
  }, []);

  function fetchOrgTree() {
    var i, j;
    var tempArray;
    var newArray = [];
    Auth.currentAuthenticatedUser()
      .then(data => {
        const sessionToken = data.signInUserSession.idToken.jwtToken;

        var requestOptions = {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': sessionToken
          }
        };

        fetch(host + '/orgs/' + orgInfo.orgId + '/manage', requestOptions)
          .then(results => results.json())
          .then(data => {
            tempArray = data;
            if(tempArray[0].users){
              tempArray[0].users.sort((a,b) => (a.name > b.name) ? 1 : -1);
            }
            newArray.push(tempArray[0]); //Org goes first
            tempArray.splice(0,1);
            tempArray.sort((a,b) => (a.name > b.name) ? 1 : -1);
            for (i=0; i < tempArray.length; i++ ){
              if (tempArray[i].children){
                tempArray[i].children.sort((a, b) => (a.name > b.name) ? 1 : -1);
              }
              if (tempArray[i].users){
                tempArray[i].users.sort((a,b) => (a.name > b.name) ? 1 : -1);
              }
              for (j=0; j < tempArray[i].children.length; j++){
                tempArray[i].children[j].users.sort((a,b) => (a.name > b.name) ? 1 : -1);
                if (tempArray[i].children[j].children){
                  //tempArray[i].chilrden[j].children.sort((a,b) => (a.name > b.name) ? 1 : -1);
                }
              }
              newArray.push(tempArray[i]);
            }
            console.log(tempArray);
            //console.log(newArray);
            //setOrgTree(data);
            setOrgTree(newArray);
          }).catch((error) => {
            console.log(error);
          });
      });
  }

  function removeUser(permission_id) {
    console.log("Delete Role");

    Auth.currentAuthenticatedUser()
      .then(data => {

        var body = JSON.stringify(
          {
            "Id": permission_id,
          }
        );
        var requestOptions = {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': data.signInUserSession.idToken.jwtToken
          },
          body: body
        };
        fetch(host + '/orgs/' + orgInfo.orgId + '/role/', requestOptions)
          .then(results => results.json())
          .then(data => {
            //console.log(data);
            if (data.error !== "OK") {
              alert(data.error);
            }
            fetchOrgTree();
          }).catch((error) => {
            console.log(error);
          });
      }).catch((error) => {
        console.log(error);
      });
  }

  function isValidEnteredEmail(value) {
    if (isValidEmail(value))
      return (true);

    alert("You have entered an invalid email address!");
    return (false);
  };

  async function inviteUser(selected, recipient, permissions) {
    var selectedId = selected.id === 'root' ? orgInfo.orgId : selected.id;
    var type = selected.type;

    recipient = recipient.trim();
    recipient = recipient.trim().replace(/,{1,}$/, '');
    var recipientArr = recipient.split(',');
    var sent = false;

    for (var index = 0; index < recipientArr.length; index++) {
      var userToInvite = recipientArr[index];

      if (isValidEnteredEmail(userToInvite)) {
        try {
          // Get current authenticated user session
          let user = await Auth.currentAuthenticatedUser();
          user.getSession((err, session) => {
            if (err) {
              console.log(err);
              return;
            }

            var body = JSON.stringify(
              {
                "Recipient": userToInvite,
                "Id": selectedId,
                "Role": permissions, //Editor, Viewer, or Member
                'User': user.attributes.email
              }
            );

            var requestOptions = {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': session.getIdToken().jwtToken
              },
              body: body
            };

            let url = host;
            var l_branchId = 0;

            if (selected.type === "ORG") {
              url = host + '/orgs/' + selectedId + '/invite';
            }
            else if (selected.type === "BRANCH") {
              url = host + '/orgs/' + orgInfo.orgId + '/branches/' + selectedId + '/invite';
            }
            else if (selected.type === "SITE") {
              for (var i = 1; i < orgTree.length; i++) {
                for (var k = 0; k < orgTree[i].children.length; k++) {
                  if (orgTree[i].children[k].id === selectedId) {
                    l_branchId = orgTree[i].id;
                    break;
                  }
                }
                if (l_branchId > 0) {
                  break;
                }
              }

              url = host + '/orgs/' + orgInfo.orgId + '/branches/' + l_branchId + '/sites/' + selectedId + '/invite';
            }

            fetch(url, requestOptions)
              .then(async response => {
                const data = await response.json();
                if (response.status == 200) {
                  if (!sent) {
                    alert('Invitation has been sent!');
                    sent = true;
                  }
                  fetchOrgTree();
                }
                else {
                  alert(data);
                }
              });
          });
        } catch (e) {
          console.log(e);
        }
      }
    }
  }

  function setUserRole(user_id, newRole) {
    //console.log(user_id);
    //console.log(newRole);
    //console.log(selected);
    var permission_id = 0;
    if (newRole !== undefined) {
      for (var i = 0; i < selected.users.length; i++) {
        if (selected.users[i].id === user_id) {
          if (selected.users[i].access !== newRole) {
            //console.log("Change Role");
            //console.log(selected.users[i]);
            permission_id = selected.users[i].id;
          }
          break;
        }
      }
    }

    if (permission_id > 0) {
      console.log("Change Role");
      Auth.currentAuthenticatedUser()
        .then(data => {

          var body = JSON.stringify(
            {
              "Id": permission_id,
              "Role": newRole,
            }
          );
          var requestOptions = {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': data.signInUserSession.idToken.jwtToken
            },
            body: body
          };

          fetch(host + '/orgs/' + orgInfo.orgId + '/role/', requestOptions)
            .then(results => results.json())
            .then(data => {
              console.log(data);
              if (data.error !== "OK") {
                alert(data.error);
              }
              fetchOrgTree();
            }).catch((error) => {
              console.log(error);
            });
        }).catch((error) => {
          console.log(error);
        });
    }
  }

  const deleteModule = async deleted => {
    //setOrgTree(removeFromTree(orgTree, deleted.id, deleted.type));
    setSelected({});
    try {
      let user = await Auth.currentAuthenticatedUser();
      user.getSession((err, session) => {
        if (err) {
          console.log(err);
          return;
        }

        const sessionToken = session.getIdToken().jwtToken;

        var requestOptions = {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': sessionToken
          }
        };

        let branchId = 1;

        switch (deleted.type) {
          case 'ORG':
            fetch(host + '/orgs/' + orgInfo.orgId, requestOptions)
              .then(response => response.json())
              .then(data => {
                console.log(data);
                if (data.error === "OK") {
                  setOrgTree(removeFromTree(orgTree, deleted.id, deleted.type));
                }
                else {
                  if (data.error.includes("billing")) {
                    alert(t("orgDeleteHasBilling"));
                  }
                  else {
                    alert(data.error);
                  }
                }
              });
            break;
          case 'BRANCH':
            fetch(host + '/orgs/' + orgInfo.orgId + '/branches/' + deleted.id, requestOptions)
              .then(response => {
                // console.log(response);
                setOrgTree(removeFromTree(orgTree, deleted.id, deleted.type));
              });
            break;
          case 'SITE':
            fetch(host + '/orgs/' + orgInfo.orgId + '/branches/' + branchId + '/sites/' + deleted.id, requestOptions)
              .then(response => {
                // console.log(response);
                setOrgTree(removeFromTree(orgTree, deleted.id, deleted.type));
              });
            break;
        };
      });
    } catch (e) {
      console.log(e);
    };
  };

  const deleteTank = async deleted => {
    setOrgTree(removeFromTree(orgTree, deleted, 'TANK'));

    try {
      let user = await Auth.currentAuthenticatedUser();
      user.getSession((err, session) => {
        if (err) {
          console.log(err);
          return;
        }

        const sessionToken = session.getIdToken().jwtToken;

        var requestOptions = {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': sessionToken
          }
        };

        let branchId = 1;
        let siteId = 1;

        fetch(host + '/orgs/' + orgInfo.orgId + '/branches/' + branchId + '/sites/' + siteId + '/tanks/' + deleted, requestOptions)
          .then(response => {
            //console.log(response);
          });
      });
    } catch (e) {
      console.log(e);
    };
  };

  const removeFromTree = (tree, childIdToRemove, type) => {
    console.log(type);
    if (type === 'ORG') {
      //let url = '/';
      //console.log(orgInfo);
      const orgTarget = "default";
      fetchOrgInformation(orgTarget);
      //history.push(url);
      return [];
    } else if (type === 'BRANCH') {
      tree.splice(tree.findIndex(item => item.id === childIdToRemove), 1);
    } else if (type === 'SITE') {
      for (var i = 0; i < tree.length; i++) {
        let item = tree[i];
        if (item.type !== 'ORG') {
          for (var ii = 0; ii < item.children.length; ii++) {
            let child = item.children[ii];
            if (child.id === childIdToRemove) {
              item.children.splice(item.children.findIndex(entry => entry.id === childIdToRemove), 1);
            }
          }
        }
      }
    } else {
      // Remove tank from orgTree
      for (var i = 0; i < tree.length; i++) {
        let item = tree[i];

        if (item.type !== 'ORG') {
          for (var ii = 0; ii < item.children.length; ii++) {
            let child = item.children[ii];

            for (var iii = 0; iii < child.children.length; iii++) {
              let tank = child.children[iii];

              if (tank.id === childIdToRemove) {
                child.children.splice(child.children.findIndex(entry => entry.id === childIdToRemove), 1);
              }
            }
          }
        }
      }
    }

    return tree;
  };

  function handleMove(parent_id, item) {
    const lSelected_id = item.id;
    const lSelected_type = item.type;
    console.log(parent_id);
    console.log(item); // Selected
    
    Auth.currentAuthenticatedUser()
        .then(data => {

          var body = JSON.stringify(
            {
              "newParentId": parent_id,
            }
          );
          var requestOptions = {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': data.signInUserSession.idToken.jwtToken
            },
            body: body
          };

          let url = host;
          let l_branchId = 0;
          let l_siteId = 0;

          if (lSelected_type === "ORG") {
            url = host + '/orgs/' + lSelected_id + '/move';
          }
          else if (lSelected_type === "BRANCH") {
            url = host + '/orgs/' + orgInfo.orgId + '/branches/' + lSelected_id + '/move';
          }
          else if (lSelected_type === "SITE") {
            for (var i = 1; i < orgTree.length; i++) {
              for (var k = 0; k < orgTree[i].children.length; k++) {
                if (orgTree[i].children[k].id === lSelected_id) {
                  l_branchId = orgTree[i].id;
                  break;
                }
              }
              if (l_branchId > 0) {
                break;
              }
            }
            url = host + '/orgs/' + orgInfo.orgId + '/branches/' + l_branchId + '/sites/' + lSelected_id + '/move';
          }
          else if (lSelected_type === "TANK") {
            for (var i = 1; i < orgTree.length; i++) {
              for (var k = 0; k < orgTree[i].children.length; k++) {
                for (var j=0; j< orgTree[i].children[k].children.length; j++){
                  if (orgTree[i].children[k].children[j].id === lSelected_id) {
                    l_branchId = orgTree[i].id;
                    l_siteId = orgTree[i].children[k].id;
                    break;
                  }
                }
                if (l_siteId > 0){
                  break;
                }
              }
              if (l_siteId > 0) {
                break;
              }
            }
            url = host + '/orgs/' + orgInfo.orgId + '/branches/' + l_branchId + '/sites/' + l_siteId + '/tanks/' + lSelected_id +'/move';
          }
          console.log(url);
          console.log(body);
          fetch(url, requestOptions)
            .then(results => results.json())
            .then(data => {
              console.log(data);
              if (data.error !== "OK") {
                if (data.error.includes("Access Denied, no permissions to modify"))
                {
                  alert(t("accessDenied_move"));
                }
                else if (data.error.includes("Tank name already exists")){
                  alert(t("nameDuplicate_move"));
                }
                else if (data.error.includes("New parent not in Organization")){
                  alert(t("invalidDestination_move"));
                }
                else{
                  alert(data.error);
                }
              }
              fetchOrgTree();
            }).catch((error) => {
              console.log(error);
            });
        }).catch((error) => {
          console.log(error);
        });
  };

  return (
    <Grid container
      alignItems='stretch'
      direction='column'
      justify='flex-start'
      className={classes.content}>
      <Grid item xs>
        <Toolbar>
          <Tooltip title={t("goHome")}>
            <IconButton color='primary'
              component={RouterLink}
              to={'/'}>
              <ArrowBack />
            </IconButton>
          </Tooltip>
          <Breadcrumbs>
            <Link variant='h5'
              component={RouterLink}
              to={'/'}>
              {t("settings")}
            </Link>
            <Typography variant='h5'>
              {t("manageOrg")}
            </Typography>
          </Breadcrumbs>
          <div className={classes.grow} />
          <BranchesNavigationButton text={t("branches_caps")} orgInfo={orgInfo} branchesList={branches} />
        </Toolbar>
      </Grid>
      <Divider className={classes.dividerSpacing} />
      <Grid item xs>
        <Grid container
          alignItems='stretch'
          direction='row'
          justify='flex-start'
          spacing={1}>
          <Grid item xs={120}>
            <OrganizationTree list={orgTree}
              selectItem={setSelected}
              action={deleteTank}
              access={ACCESS.OWNER} />
          </Grid>
          <Grid item xs>
            <ItemDelete access={ACCESS.OWNER}
              selected={selected}
              action={deleteModule}
              inviteUser={inviteUser}
              allowItemDelete={allowItemDelete}
              moveDestinations={moveDestinations}
              handleMove={handleMove} />
            {
              <UserTable access={ACCESS.OWNER}
                users={selected.users}
                removeUser={removeUser}
                setUserRole={setUserRole}
                currentUser={currentUser} />
            }
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};